/**
 * Created by Diana Agliamutdinova on 01.05.2019.
 */

/**
 * @class Represents program of one robot.
 */
var PiktoTreeCreator = cc.Class.extend({

	_visualTree: null,

	ctor: function (programTree, robot, programContainer)
	{
		this._visualTree = new PiktoTree(
			programTree,
			robot,
			programContainer);
	},

	getVisualTree: function()
	{
		return this._visualTree.getVisualTree();
	},

	updateTree: function (node, parent)
	{
		this._visualTree.updateTree(node, parent);
	},

	switchPointsInRepeater: function (nodeView, num, rep)
	{
		this._visualTree.switchPointsInRepeater(nodeView, num, rep);
	},

	highlightMethod: function (nodeView)
	{
		this._visualTree.highlightMethod(nodeView);
	},

	highlightMethodBroken: function (nodeView)
	{
		this._visualTree.highlightMethodBroken(nodeView);
	},

	clearLastHighlight: function ()
	{
		this._visualTree.clearLastHighlight();
	},

	clearAllHighlight: function ()
	{
		this._visualTree.clearAllHighlight();
	},

	reloadRepeaters: function()
	{
		this._visualTree.reloadRepeaters();
	},

	pasteNode: function (parent, button, selectedElem)
	{

	},

	pasteNodeList: function (element, methodList)
	{

	},

	moveNode: function(node, selectedNode)
	{

	},

	addOutput: function (outputRobot)
	{},

	reset: function ()
	{
		this.clearAllHighlight();
		this.reloadRepeaters();
	}
});
